module.exports = __webpack_public_path__ + "img/Degrees-Distributions.9c784c18.png";